<template>
  <CBox
    :bg="['none', 'var(--colors-light-primary-light-gray)']"
    :minHeight="['auto', 'calc(100vh - 80px)']"
    width="100vw"
    position="sticky"
    pt="10px"
  >
    <OmtGrid pt="40px">
      <OmtRow>
        <OmtTypography as="h1-bold" mb="40px">Protocolo {{ protocol }}</OmtTypography>
      </OmtRow>

      <OmtRow>
        <div class="info-grid">
          <TextTile :title="'Assunto'" :description="detail.title" />
          <TextTile :title="'Data da solicitação'" :description="detail.createdAt" />
          <TextTile :title="'Beneficiário'" :description="detail.beneficiaryName" />
          <TextTile v-if="!isMobile" :title="'Código do associado'" :description="detail.beneficiaryCode" />
          <div>
            <OmtTypography as="p2" color="var(--colors-light-primary-gray2)"> Status </OmtTypography>
            <StatusTile :label="detail.statusDsc" :color="statusColor" />
          </div>
        </div>
      </OmtRow>

      <OmtRow
        v-if="isAnalyzingStatus"
        mt="32px"
        :desktopEnd="12"
        border="0.5px solid var(--colors-light-secondary-divider)"
        border-radius="8px"
        py="19px"
        px="16px"
      >
        <CBox>
          <CFlex align="center" justify="space-between" mb="16px">
            <CFlex align="center">
              <CBox
                bg="#1CA0FF"
                border-radius="50%"
                w="24px"
                h="24px"
                display="flex"
                align-items="center"
                justify-content="center"
                mr="12px"
              >
                <OmtIcons name="user" size="1x" color="#ffffff" />
              </CBox>
              <OmtTypography as="h2-bold"> Sua solicitação </OmtTypography>
            </CFlex>
            <OmtTypography as="p2" color="var(--colors-light-primary-gray2)">
              {{ detail.createdAt }}
            </OmtTypography>
          </CFlex>
          <OmtTypography as="p1" color="var(--colors-light-primary-gray2)" ml="36px">
            {{ requestDescription }}
          </OmtTypography>

          <CGrid v-if="pictures.length" class="image-grid" mt="12px" ml="36px">
            <ImagePreviewer
              v-for="(picture, index) in pictures"
              :key="'img-' + index"
              v-bind="picture"
              :source="picture.source"
              style="width: 32px; height: 32px; border-radius: 4px; object-fit: contain"
            />
          </CGrid>
        </CBox>
      </OmtRow>

      <OmtRow
        v-else-if="detail.statusCode === 'F'"
        mt="32px"
        :desktopEnd="12"
        border="0.5px solid var(--colors-light-secondary-divider)"
        border-radius="8px"
        py="19px"
        px="16px"
        class="timeline-block"
      >
        <div class="timeline-container">
          <div class="timeline-item">
            <CBox class="timeline-icon" bg="#1CA0FF">
              <OmtIcons name="user" size="1x" color="white" />
            </CBox>

            <div class="timeline-content">
              <CFlex align="center" justify="space-between" mb="4px">
                <OmtTypography as="h2-bold">Sua solicitação</OmtTypography>
                <OmtTypography as="p2" color="var(--colors-light-primary-gray2)">
                  {{ detail.createdAt }}
                </OmtTypography>
              </CFlex>

              <OmtTypography as="p1" color="var(--colors-light-primary-gray2)" mt="8px">
                {{ requestDescription }}
              </OmtTypography>

              <CGrid v-if="pictures.length" class="image-grid" mt="12px">
                <ImagePreviewer
                  v-for="(picture, index) in pictures"
                  :key="'img-final-' + index"
                  v-bind="picture"
                  :source="picture.source"
                />
              </CGrid>
            </div>
          </div>

          <div v-for="(r, idx) in hasResponse" :key="'resp-' + idx" class="timeline-item">
            <CBox class="timeline-icon" bg="#0052CC">
              <img :src="IconOmint" style="width: 16px; height: 16px" />
            </CBox>

            <div class="timeline-content">
              <CFlex align="center" justify="space-between" mb="4px">
                <OmtTypography as="h2-bold">Resposta Omint</OmtTypography>
                <OmtTypography as="p2" color="var(--colors-light-primary-gray2)">
                  {{ r.DataResposta }}
                </OmtTypography>
              </CFlex>

              <OmtTypography as="p1" mt="8px">{{ r.Resposta }}</OmtTypography>
            </div>
          </div>

          <div
            v-if="hasPendency && detail.statusCode !== 'F' && detail.pendency && detail.pendency.days > 0"
            class="cancellation-warning"
          >
            <div class="warning-header">
              <div class="warning-icon">!</div>
              <OmtTypography as="h3-bold">Motivo:</OmtTypography>
            </div>

            <OmtTypography as="p1" mt="8px">
              {{ detail.pendency.observation || "Procedimentos não descritos" }}
            </OmtTypography>

            <div class="divider"></div>

            <OmtTypography as="p2">
              <strong>Responda em até {{ detail.pendency.days }} dias</strong>
              ou a solicitação será cancelada.
            </OmtTypography>
          </div>
        </div>
      </OmtRow>

      <OmtRow v-if="hasPendency" mt="32px" flex-direction="column">
        <CBox bg="#F6F6F9" border-radius="8px" p="20px" w="100%">
          <CFlex align="flex-start">
            <CBox
              w="24px"
              h="24px"
              border-radius="50%"
              display="flex"
              align-items="center"
              justify-content="center"
              mr="14px"
              mt="2px"
            >
              <img :src="IconOmint" />
            </CBox>
            <CBox>
              <OmtTypography as="h3-bold" font-size="md" color="var(--colors-light-primary-dark-blue)" mb="12px">
                Para continuidade da análise, solicitamos:
              </OmtTypography>

              <ul class="pendency-list">
                <li v-for="(reason, i) in pendencyReasons" :key="'reason-' + i">
                  <OmtTypography as="p1" color="var(--colors-light-primary-gray1)">
                    {{ reason }}
                  </OmtTypography>
                </li>
              </ul>
            </CBox>
          </CFlex>
        </CBox>

        <CBox text-align="center" mb="40px" w="100%" mt="20px">
          <OmtButton
            bg="var(--colors-light-primary-dark-blue)"
            color="white"
            w="100%"
            h="50px"
            font-size="md"
            @click="modalPendencies = true"
          >
            Responder pendência
          </OmtButton>
        </CBox>
      </OmtRow>

      <PendingResponseModal
        :reasons="pendencyReasons"
        :pendencyObservation="pendencyObservation"
        :isOpen="modalPendencies"
        @close="closeModal"
        @submit="submit"
      />

      <SendPendency
        :daysAnalizy="daysAnalizy"
        :isOpen="openModalSuccess"
        :protocol="protocolANS"
        @close="closeModalSendPendency"
      />

      <Footer />
    </OmtGrid>
  </CBox>
</template>

<script>
import Footer from "@/components/Molecules/Footer";
import ImagePreviewer from "@/components/Molecules/ImagePreviewer";
import TextTile from "@/components/Molecules/TextTile";
import PendingResponseModal from "@/components/Organisms/Requests/PendingResponseModal.vue";
import SendPendency from "@/components/Organisms/Requests/SendPendency.vue";
import StatusTile from "@/components/Organisms/Requests/StatusTile.vue";
import { mapActions } from "vuex";
import { isMobile } from "@/utils/utils";

export default {
  name: "DetailRequest",
  components: { TextTile, StatusTile, Footer, PendingResponseModal, SendPendency, ImagePreviewer },
  data() {
    return {
      detail: {},
      modalPendencies: false,
      openModalSuccess: false,
      pictures: [],
      protocolANS: "",
      daysAnalizy: 3
    };
  },
  computed: {
    isAnalyzingStatus() {
      return this.detail?.statusDsc === "Em análise";
    },
    hasResponse() {
      const raw = this.detail?.doc?.resp;
      if (!raw) return [];
      const arr = Array.isArray(raw) ? raw : [raw];
      return arr.filter(r => r?.Resposta && r.Resposta.trim().length > 0);
    },
    protocol() {
      return this.$route.params.protocol ?? "";
    },
    statusColor() {
      switch (this.detail.statusCode) {
        case "F":
          return "var(--colors-light-support-success)";
        case "P":
          return "var(--colors-light-support-warning)";
        default:
          return "var(--colors-light-primary-dark-blue)";
      }
    },
    hasPendency() {
      return this.detail?.statusCode === "P" && this.detail?.pendency?.ticket > 0 && this.pendencyReasons.length > 0;
    },
    pendencyReasons() {
      return this.detail?.pendency?.reasons ?? [];
    },
    pendencyObservation() {
      return this.detail?.pendency?.observation ?? "";
    },
    isMobile() {
      return isMobile();
    },
    IconOmint() {
      return process.env.VUE_APP_BASE_URL + "images/Group3305.png";
    },
    requestDescription() {
      const d = this.detail;
      if (!d) return;

      const fields = [d.description];

      for (const f of fields) {
        if (f !== null && f !== undefined) {
          const text = String(f).trim();
          if (text.length > 0) return text;
        }
      }
    }
  },
  methods: {
    ...mapActions("request", [
      "getDocumentUrl",
      "fetchProtocolDetailImage",
      "fetchProtocolDetail",
      "returnRequestTicket"
    ]),
    async loadPictures() {
      if (!this.detail?.pictures?.length) return;
      this.pictures = [];
      for (const p of this.detail.pictures) {
        const source = await this.fetchProtocolDetailImage({ documento: p, original: false });
        this.pictures.push({ id: p, source, loadModalImage: () => this.loadPicture(p) });
      }
    },
    async loadPicture(id) {
      return await this.fetchProtocolDetailImage({ documento: id, original: true });
    },
    async getDetail() {
      const detail = await this.fetchProtocolDetail({ protocol: this.protocol });
      if (!detail) {
        this.$router.replace("/solicitacoes");
        return;
      }
      this.detail = detail;
      await this.loadPictures();
    },
    async download() {
      window.open(await this.getDocumentUrl({ protocol: this.protocol }), "_blank");
    },
    closeModal() {
      this.modalPendencies = false;
    },
    async submit({ pictures, obs }) {
      if (!this.hasPendency) return;
      let response = {};
      try {
        await this.$root.$emit("show-loading");
        response = await this.returnRequestTicket({ protocol: this.protocol, pictures, obs });
      } finally {
        await this.$root.$emit("hide-loading");
      }
      if (response?.Data) {
        this.daysAnalizy = response.Data.prazos;
        this.protocolANS = response.Data.protocoloANS;
        this.modalPendencies = false;
        this.openModalSuccess = true;
        const detail = await this.fetchProtocolDetail({ protocol: this.protocol });
        if (detail) this.detail = detail;
      } else {
        await this.$toast({
          description: "Não foi possível registrar o atendimento.\nServiço temporariamente indisponível.",
          status: "error",
          duration: 10000,
          position: "top"
        });
      }
    },
    closeModalSendPendency() {
      this.openModalSuccess = false;
    }
  },
  async mounted() {
    try {
      this.$root.$emit("show-loading");
      await this.getDetail();
    } catch (error) {
      console.error("Erro ao carregar detalhe:", error);
    } finally {
      this.$root.$emit("hide-loading");
    }
  }
};
</script>

<style scoped>
.info-grid {
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 16px;
}
@media (min-width: 768px) {
  .info-grid {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 120px;
  }
}

.pendency-list {
  list-style-type: decimal;
  padding-left: 20px;
  margin: 0;
  line-height: 1.5;
}
.pendency-list li {
  margin-bottom: 6px;
}

.timeline-block {
  position: relative;
}
.timeline-container {
  position: relative;
  padding-left: 26px;
}
.timeline-container::before {
  content: "";
  position: absolute;
  left: 24px;
  height: 90px;
  top: 0;
  bottom: 0;
  width: 2px;
  border-left: 2px dashed var(--colors-light-secondary-divider);
  z-index: 1;
}
.timeline-item {
  position: relative;
  margin-bottom: 24px;
  display: flex;
  align-items: flex-start;
}
.timeline-icon {
  position: absolute;
  left: -12px;
  top: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.timeline-content {
  width: 100%;
  display: flex;
  padding-left: 32px;
  flex-direction: column;
}

.image-grid {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  overflow: hidden;
}

.image-grid > * img {
  width: 32px;
  height: 32px !important;
  object-fit: cover;
  object-position: center;
  image-rendering: auto;
}

.cancellation-warning {
  margin-top: 20px;
  padding: 16px;
  border-radius: 8px;
  background: #fafafb;
  border: 1px solid #e1e1e6;
}

.warning-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.warning-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #6b6b76;
  color: #6b6b76;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-right: 8px;
}

.divider {
  margin: 12px 0;
  height: 1px;
  background: #e1e1e6;
}
</style>
